// AI Generated Component
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PagesService } from './pages.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { LinkPagesRepoService } from '@client/app/services/api/link-pages-repo/link-pages-repo.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-files-pages',
    templateUrl: './pages.html',
    standalone: false,
})
export class PagesFilesPagesComponent extends BaseContainerComponentController implements OnInit {
    @Input() link: any;
    @Input() domainId!: string;
    @Input() active?: any;
    @Input() icon: any;
    @Input() type?: string;

    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    pages: any = { total: 0 };
    exports: any[] = [];
    dialogHeader: string = '';
    promise!: Promise<any>;
    showUnwantedViolations: boolean = false;
    showNormalViolations: boolean = false;

    constructor (
        private translateService: TranslateService,
        private pagesService: PagesService,
        private activeFeatureService: ActiveFeatureService,
        private linkPagesRepoService: LinkPagesRepoService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [];
        this.pages.total = 0;
        this.search = '';
        this.currentSort = { by: 'hits', direction: 'desc' };
        this.exports = [
            {
                name: this.translateService.getString('Start export Pages With Specific Link'),
                data: {
                    category: 'pages_with_specific_link',
                    category_ref: this.link.id,
                },
            },
        ];
        this.dialogHeader = this.pagesService.getHeaderTranslation(this.link.type, this.type || '');
        this.getPage = this.getPageData;
        this.getPageData();
    }

    getPageData (): void {
        const params = {
            domainId: this.domainId,
            link_id: this.link.id,
            page_size: this.pageSize,
            page: this.page,
            search: this.search ?? '',
            'types[]': this.type == 'document' ? ['document', 'pdf'] : ['html'],
            dialogHeader: this.dialogHeader,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        this.promise = this.linkPagesRepoService.get(params).then((data) => {
            this.pages = data;
        }, () => {});
    }

    trackByFn (index: number, item: any): any {
        return item.id || index;
    }
}
